import Swiper from 'swiper'
import 'swiper/css/swiper.css'
export const imgPreview = {
  data() {
    const that = this
    return {
      currentImgIndex: 0, // 当前展示内容,
      showMode: 0, // 0 图片 -- 1 视频
      swiperOptionP: {
        slidesPerView: 6,
        spaceBetween: 10,
        freeMode: true,
        slideToClickedSlide: true, // 点击slide会过渡到这个slide
        preventClicksPropagation: true, // 拖动时阻止事件触发
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        // pagination: {
        //   // el: '.swiper-pagination',
        //   clickable: false,
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          hideOnClick: true,
          disabledClass: 'swiper-btn-disable-none'
        }
      },
      swiperOptionM: {
        // slidesPerView: 'auto',
        // spaceBetween: 20,
        clickable: true,
        // freeMode: true,
        // slideToClickedSlide: true, // 点击slide会过渡到这个slide
        preventClicksPropagation: true, // 拖动时阻止事件触发
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        // pagination: {
        //   // el: '.swiper-pagination',
        //   clickable: false,
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        //   hideOnClick: true,
        //   disabledClass: 'swiper-btn-disable-none'
        // }
        on: {
          slideChangeTransitionStart: function () {
            that.currentImgIndex = this.activeIndex
          }
        }
      },
      mobileSwiper: null
    }
  },
  // watch: {
  //   '$vuetify.breakpoint.mdAndUp': {
  //     handler(val) {
  //       if (val) {
  //         console.log(1)
  //       } else {
  //         console.log(2)
  //       }
  //     }
  //   }
  // },
  mounted() {
    this.$nextTick(() => {
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.initPcSwiper()
      } else {
        this.initMobileSwiper()
      }
    })
  },
  methods: {
    initPcSwiper() {
      // eslint-disable-next-line no-new
      new Swiper('.mySwiperP', this.swiperOptionP)
    },
    initMobileSwiper() {
      // eslint-disable-next-line no-new
      this.mobileSwiper = new Swiper('.mySwiperM', this.swiperOptionM)
    },
    // 点击查看大图
    swiperPreview(index) {
      this.currentImgIndex = index
      this.preview()
    },
    changeImgView(type) {
      if (type === 'prev' && this.currentImgIndex > 0) {
        this.currentImgIndex--
      }
      if (type === 'next' && this.currentImgIndex < this.info.image.length - 1) {
        this.currentImgIndex++
      }
    }
  }
}
